(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cct-mold-planner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cct-mold-planner')) {
  customElements.define('cct-mold-planner', class CCTMoldPlanner extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      if (!this.querySelector('[data-cct-ready]')) {
        if (this._waiting) this._waiting.disconnect();
        this._waiting = new MutationObserver(() => {
          if (!this.querySelector('[data-cct-ready]')) return;
          this._waiting.disconnect();
          this.connectedCallback();
        });
        this._waiting.observe(this, { childList:true, subtree:true });
        return;
      }
      this._connected = true;
      this._abort = new AbortController();
      this._locale = document.documentElement.lang || 'en';
      this._mobileQuery = window.matchMedia('(max-width: 760px)');
      this._swipe = null;
      this._slide = null;
      this._selected = null;
      this._unit = this.dataset.currentUnit || 'in';
      this._view = null;
      this._fields = {};
      this.querySelectorAll('[data-field]').forEach(el => { this._fields[el.dataset.field] = el; });
      this._molds = Array.from(this.querySelectorAll('[data-mold-record]')).map((el, index) => ({
        id:el.dataset.id, name:el.dataset.name || 'Mold',
        length:Number(el.dataset.length), width:Number(el.dataset.width), depth:Number(el.dataset.depth),
        url:this.safeURL(el.dataset.url), price:el.dataset.price || '', unavailable:el.dataset.unavailable === 'true', index
      })).filter(m => [m.length,m.width,m.depth].every(v => Number.isFinite(v) && v > 0 && v <= 10000));
      const signal = this._abort.signal;
      ['width','height','thickness','target'].forEach(key => {
        this._fields[key].addEventListener('input', () => this.update(true), { signal });
      });
      this.querySelectorAll('[data-fit]').forEach(el => el.addEventListener('change', () => this.update(true), { signal }));
      this._fields.unit.addEventListener('change', () => this.changeUnit(this._fields.unit.value), { signal });
      this._fields.split.addEventListener('change', () => this.draw(), { signal });
      const track = this.role('results');
      track.addEventListener('click', event => {
        const button = event.target.closest('[data-select-mold]');
        if (button && this.contains(button)) this.select(button.dataset.selectMold);
      }, { signal });
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(this._sliderFrame);
        this._sliderFrame = requestAnimationFrame(() => this.syncSlider());
      }, { signal, passive:true });
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.moveSlider(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          track.scrollTo({ left:event.key === 'Home' ? 0 : track.scrollWidth, behavior:'auto' });
        }
      }, { signal });
      this.role('previous').addEventListener('click', () => this.moveSlider(-1), { signal });
      this.role('next').addEventListener('click', () => this.moveSlider(1), { signal });
      this.setupMobileNavigation(signal);
      document.addEventListener('shopify:block:select', event => {
        const id = event.detail && event.detail.blockId;
        if (!this._molds.some(m => m.id === id)) return;
        this._selected = id;
        this.update(false);
      }, { signal });
      const resize = () => {
        const width = this.role('diagram').getBoundingClientRect().width;
        if (width === this._lastDiagramWidth) return;
        this._lastDiagramWidth = width;
        cancelAnimationFrame(this._frame);
        this._frame = requestAnimationFrame(() => { this.draw(); this.syncSlider(); this.updateFloatingVisibility(); });
      };
      if (typeof ResizeObserver !== 'undefined') {
        this._resize = new ResizeObserver(resize);
        this._resize.observe(this.querySelector('.cct-plan__inner'));
      } else {
        window.addEventListener('resize', resize, { signal });
      }
      this._lastDiagramWidth = null;
      this._fields.unit.value = (this.dataset.currentUnit || this.dataset.defaultUnit) === 'mm' ? 'mm' : 'in';
      if (this._fields.unit.value !== this._unit) this.changeUnit(this._fields.unit.value);
      else { this.updateReference(); this.update(true); }
      this.dataset.currentUnit = this._unit;
      this.updateLayoutMode();
    }

    disconnectedCallback() {
      this.cancelMobileSlide();
      if (this._waiting) this._waiting.disconnect();
      if (this._abort) this._abort.abort();
      if (this._resize) this._resize.disconnect();
      cancelAnimationFrame(this._frame);
      cancelAnimationFrame(this._sliderFrame);
      cancelAnimationFrame(this._floatingFrame);
      if (this._floating) {
        const nav = this.querySelector('.cct-plan__mobile-nav');
        if (nav) this._floating.querySelectorAll('button').forEach(button => nav.appendChild(button));
        this._floating.remove();
        this._floating = null;
      }
      this._swipe = null;
      this._connected = false;
    }

    role(name) { return this.querySelector('[data-role="' + name + '"]') || (this._floating && this._floating.querySelector('[data-role="' + name + '"]')); }
    number(value, digits) {
      return new Intl.NumberFormat(this._locale, { minimumFractionDigits:digits, maximumFractionDigits:digits }).format(value);
    }
    measure(inches, precise) {
      return new Intl.NumberFormat(this._locale, { maximumFractionDigits:precise ? 6 : (this._unit === 'mm' ? 2 : 3) }).format(inches * (this._unit === 'mm' ? 25.4 : 1));
    }
    unitLabel() { return this._unit === 'mm' ? ' mm' : '″'; }
    safeURL(value) {
      if (!value) return '';
      try {
        const url = new URL(value, window.location.origin);
        return url.protocol === 'https:' || (url.protocol === 'http:' && url.origin === window.location.origin) ? url.href : '';
      } catch (error) { return ''; }
    }
    element(tag, className, text) {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text !== undefined) el.textContent = text;
      return el;
    }

    changeUnit(next) {
      if (!['in','mm'].includes(next)) return;
      const oldFactor = this._unit === 'mm' ? 25.4 : 1;
      const newFactor = next === 'mm' ? 25.4 : 1;
      ['width','height','thickness'].forEach(key => {
        const field = this._fields[key];
        if (field.value !== '' && Number.isFinite(Number(field.value))) {
          field.value = String(Number((Number(field.value) / oldFactor * newFactor).toFixed(8)));
        }
      });
      this._unit = next;
      this.dataset.currentUnit = next;
      this._fields.unit.value = next;
      this.querySelectorAll('[data-unit-label]').forEach(el => { el.textContent = '(' + next + ')'; });
      this.updateReference();
      this.update(false);
    }

    updateReference() {
      this.querySelectorAll('[data-reference-id]').forEach(row => {
        const mold = this._molds.find(m => m.id === row.dataset.referenceId);
        row.hidden = !mold;
        if (mold) row.querySelector('[data-reference-dimensions]').textContent = [mold.length,mold.width,mold.depth].map(v => this.measure(v)).join(' × ');
      });
    }

    fit(mold, values) {
      const epsilon = 1e-7;
      if (mold.unavailable && this.dataset.recommendUnavailable !== 'true') return null;
      if (values.height > mold.depth + epsilon) return null;
      const layouts = [[mold.width,mold.length],[mold.length,mold.width]].map(([across,along]) => {
        const loaves = Math.max(0, Math.floor((across + epsilon) / values.width));
        const slices = Math.max(0, Math.floor((along + epsilon) / values.thickness));
        return { across,along,loaves,slices,capacity:loaves * slices };
      }).filter(layout => Number.isSafeInteger(layout.capacity) && layout.capacity > 0 &&
        (!values.exact || Math.abs(layout.across - layout.loaves * values.width) <= epsilon))
        .sort((a,b) => b.capacity - a.capacity);
      if (!layouts.length) return null;
      const layout = layouts[0];
      const needed = Math.ceil(values.target / layout.capacity);
      return Object.assign({}, layout, {
        mold,needed,excess:needed * layout.capacity - values.target,
        remainder:Math.max(0, 1 - layout.capacity * values.width * values.thickness / (layout.across * layout.along))
      });
    }

    update(recommend) {
      this.cancelMobileSlide();
      const factor = this._unit === 'mm' ? 25.4 : 1;
      const values = { exact:this.querySelector('[data-fit]:checked').value === 'exact' };
      let valid = true;
      ['width','height','thickness','target'].forEach(key => {
        const field = this._fields[key];
        const number = Number(field.value);
        if (field.value === '' || !Number.isFinite(number) || !field.checkValidity()) valid = false;
        values[key] = key === 'target' ? number : number / factor;
      });
      const dimensionsValid = ['width','height','thickness'].every(key =>
        this._fields[key].value !== '' && this._fields[key].checkValidity() && Number.isFinite(values[key]) && values[key] > 0 && values[key] <= 10000);
      valid = valid && dimensionsValid && Number.isInteger(values.target) && values.target >= 1 && values.target <= 100000;
      const ounces = values.width * values.height * values.thickness * 0.554;
      this.role('bar-weight').textContent = dimensionsValid ? (this._unit === 'mm' ? this.number(ounces * 28.349523125,0) + ' g' : this.number(ounces,2) + ' oz') : '—';
      this.role('fit-note').hidden = !values.exact;
      this.role('message').hidden = true;
      this.role('results').replaceChildren();
      this.role('recommendations').hidden = true;
      this.role('detail').hidden = true;
      if (this._floating) this._floating.hidden = true;
      this._view = null;
      if (!valid) { this.message('Enter positive bar dimensions and a whole number of bars.'); return; }
      if (!this._molds.length) { this.message('Mold recommendations are being updated. Please use the product listings or contact us for help choosing.'); return; }
      const results = this._molds.map(m => this.fit(m,values)).filter(Boolean).sort((a,b) =>
        a.needed - b.needed || a.excess - b.excess || a.remainder - b.remainder || a.mold.index - b.mold.index);
      if (!results.length) {
        this.message(values.exact ? 'No listed mold has an exact loaf-width fit. Choose “With trim” or try a different bar size.' : 'No listed mold fits these dimensions. Try a different bar size or contact us for a custom mold.');
        return;
      }
      if (recommend || !results.some(r => r.mold.id === this._selected)) this._selected = results[0].mold.id;
      this._view = { values,results };
      results.forEach(result => this.resultCard(result,results[0].mold.id));
      this.role('recommendations').hidden = false;
      this.role('detail').hidden = false;
      this.select(this._selected);
      this.revealSelected();
      this.syncSlider();
      this.updateFloatingVisibility();
    }

    message(text) { this.role('message').textContent = text; this.role('message').hidden = false; }

    resultCard(result, bestID) {
      const card = this.element('article','cct-plan__result');
      const button = this.element('button','cct-plan__select');
      button.type = 'button';
      button.dataset.selectMold = result.mold.id;
      button.setAttribute('aria-pressed',String(result.mold.id === this._selected));
      const name = this.element('span','cct-plan__name',result.mold.name);
      if (result.mold.id === bestID) name.appendChild(this.element('span','cct-plan__badge','Closest batch capacity'));
      const dimensions = [result.mold.length,result.mold.width,result.mold.depth].map(v => this.measure(v)).join(' × ') + this.unitLabel() + ' inside';
      button.append(name,this.element('span','cct-plan__dimensions',dimensions),
        this.element('span','cct-plan__yield',result.capacity + ' bars / mold'),
        this.element('span','cct-plan__count',result.needed + (result.needed === 1 ? ' mold' : ' molds') + ' needed · capacity ' + result.needed * result.capacity + ' bars'));
      const cubicInches = result.mold.length * result.mold.width * result.mold.depth;
      const oilPounds = cubicInches * 0.025;
      const capacity = this.element('span','cct-plan__capacity');
      capacity.append(this.element('span','','Est. oil capacity: ' + this.number(oilPounds,1) + ' lb / ' + this.number(oilPounds * 0.45359237,2) + ' kg'),
        this.element('span','','Volume: ' + this.number(cubicInches * 0.016387064,2) + ' L / ' + this.number(cubicInches * 128 / 231,1) + ' US fl oz'));
      button.appendChild(capacity);
      if (result.mold.unavailable) button.appendChild(this.element('span','cct-plan__unavailable','Currently unavailable'));
      card.appendChild(button);
      if (result.mold.price || result.mold.url) {
        const buy = this.element('div','cct-plan__buy');
        if (result.mold.price) buy.appendChild(this.element('span','',result.mold.price));
        if (result.mold.url) {
          const link = this.element('a','','View mold');
          link.href = result.mold.url;
          link.setAttribute('aria-label','View ' + result.mold.name + ' mold');
          buy.appendChild(link);
        }
        card.appendChild(buy);
      }
      this.role('results').appendChild(card);
    }

    select(id, duringSlide) {
      if (!this._view) return;
      const result = this._view.results.find(r => r.mold.id === id);
      if (!result) return;
      if (!duringSlide) this.cancelMobileSlide();
      this._selected = id;
      this.querySelectorAll('[data-select-mold]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.selectMold === id)));
      this.updateMobileInfo(result);
      this.draw();
    }

    isMobile() { return this._mobileQuery.matches; }

    setupMobileNavigation(signal) {
      const previous = this.role('mobile-previous'),next = this.role('mobile-next');
      this._floating = this.element('div','cct-plan__floating-nav');
      this._floating.hidden = true;
      this._floating.dataset.cctOwner = this.id;
      const colors = getComputedStyle(this);
      ['--cct-plan-accent','--cct-plan-paper','--cct-plan-ink'].forEach(name => this._floating.style.setProperty(name,colors.getPropertyValue(name)));
      this._floating.append(previous,next);
      document.body.appendChild(this._floating);
      this.role('mobile-previous').addEventListener('click', () => this.navigateMold(-1), { signal });
      this.role('mobile-next').addEventListener('click', () => this.navigateMold(1), { signal });
      this._mobileQuery.addEventListener('change', () => this.updateLayoutMode(), { signal });
      const detail = this.role('detail');
      detail.addEventListener('keydown', event => {
        if (!this.isMobile() || !this._view || event.target !== detail) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.navigateMold(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          const results = this._view.results;
          this.slideToMold(results[event.key === 'Home' ? 0 : results.length - 1].mold.id,event.key === 'Home' ? -1 : 1);
        }
      }, { signal });
      detail.addEventListener('pointerdown', event => {
        this._swipe = null;
        if (!this.isMobile() || !this._view || this._slide || !event.isPrimary || !['touch','pen'].includes(event.pointerType)) return;
        if (event.target.closest('a,button,input,select,textarea,label,summary')) return;
        this._swipe = { id:event.pointerId,x:event.clientX,y:event.clientY };
        try { detail.setPointerCapture(event.pointerId); } catch (error) { /* Pointer already released. */ }
      }, { signal });
      detail.addEventListener('pointerup', event => {
        const start = this._swipe;
        this._swipe = null;
        if (!start || start.id !== event.pointerId || !this.isMobile()) return;
        const dx = event.clientX - start.x,dy = event.clientY - start.y;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        if (event.cancelable) event.preventDefault();
        this.navigateMold(dx < 0 ? 1 : -1);
      }, { signal });
      detail.addEventListener('pointercancel', () => { this._swipe = null; }, { signal });
      const refreshFloating = () => {
        cancelAnimationFrame(this._floatingFrame);
        this._floatingFrame = requestAnimationFrame(() => this.updateFloatingVisibility());
      };
      document.addEventListener('scroll',refreshFloating,{ signal,passive:true,capture:true });
      window.addEventListener('resize',refreshFloating,{ signal,passive:true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize',refreshFloating,{ signal,passive:true });
        window.visualViewport.addEventListener('scroll',refreshFloating,{ signal,passive:true });
      }
    }

    updateLayoutMode() {
      this.cancelMobileSlide();
      const detail = this.role('detail');
      this._swipe = null;
      if (this.isMobile()) {
        detail.tabIndex = 0;
        detail.setAttribute('role','region');
        detail.setAttribute('aria-roledescription','carousel');
        detail.setAttribute('aria-labelledby',this.role('layout-title').id);
      } else {
        ['tabindex','role','aria-roledescription','aria-labelledby'].forEach(name => detail.removeAttribute(name));
        this.revealSelected();
      }
      this.draw();
      this.syncSlider();
      const result = this._view && this._view.results.find(r => r.mold.id === this._selected);
      if (result) this.updateMobileInfo(result);
      this.updateFloatingVisibility();
    }

    revealSelected() {
      if (this.isMobile() || !this._view) return;
      const track = this.role('results');
      const button = Array.from(track.querySelectorAll('[data-select-mold]')).find(el => el.dataset.selectMold === this._selected);
      if (!button || !track.firstElementChild) return;
      track.scrollLeft = button.closest('article').offsetLeft - track.firstElementChild.offsetLeft;
    }

    navigateMold(direction) {
      if (!this.isMobile() || !this._view || this._slide) return;
      const results = this._view.results,index = results.findIndex(r => r.mold.id === this._selected);
      const next = Math.max(0,Math.min(results.length - 1,index + direction));
      if (next !== index) this.slideToMold(results[next].mold.id,direction);
    }

    updateFloatingVisibility() {
      if (!this._floating) return;
      const screen = window.visualViewport;
      const center = screen ? screen.offsetTop + screen.height / 2 : window.innerHeight / 2;
      const detail = this.role('detail'),box = detail.getBoundingClientRect();
      this._floating.style.setProperty('--cct-floating-y',center + 'px');
      this._floating.hidden = !this.isMobile() || !this._view || this._view.results.length < 2 || detail.hidden || box.top > center || box.bottom < center;
    }

    cancelMobileSlide() {
      const slide = this._slide;
      if (!slide) return;
      this._slide = null;
      slide.animations.forEach(animation => animation.cancel());
      slide.ghost.remove();
      slide.viewport.style.height = '';
    }

    slideToMold(id, direction) {
      if (!this._view || this._slide || id === this._selected) return;
      const detail = this.role('detail'),viewport = this.role('detail-viewport');
      if (!this.isMobile() || window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof detail.animate !== 'function' || !viewport.clientWidth) {
        this.select(id);
        return;
      }
      const height = detail.getBoundingClientRect().height,ghost = detail.cloneNode(true);
      ghost.classList.add('cct-plan__slide-ghost');
      ghost.inert = true;
      ghost.setAttribute('aria-hidden','true');
      [ghost,...ghost.querySelectorAll('*')].forEach(node => {
        ['id','data-role','data-field','name','for','tabindex'].forEach(name => node.removeAttribute(name));
      });
      viewport.style.height = height + 'px';
      viewport.appendChild(ghost);
      const slide = { ghost,viewport,animations:[] };
      this._slide = slide;
      this.select(id,true);
      const nextHeight = detail.getBoundingClientRect().height,distance = viewport.clientWidth + 12;
      const options = { duration:320,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both' };
      slide.animations = [
        ghost.animate([{ transform:'translateX(0)' },{ transform:'translateX(' + (-direction * distance) + 'px)' }],options),
        detail.animate([{ transform:'translateX(' + (direction * distance) + 'px)' },{ transform:'translateX(0)' }],options),
        viewport.animate([{ height:height + 'px' },{ height:nextHeight + 'px' }],options)
      ];
      Promise.all(slide.animations.map(animation => animation.finished)).then(() => {
        if (this._slide !== slide) return;
        this.cancelMobileSlide();
        const result = this._view && this._view.results.find(r => r.mold.id === this._selected);
        if (result) this.updateMobileInfo(result);
        this.updateFloatingVisibility();
      }).catch(() => { /* A field, unit or layout change canceled the transition. */ });
    }

    updateMobileInfo(result) {
      const mold = result.mold,results = this._view.results;
      const index = results.findIndex(r => r.mold.id === mold.id);
      this.role('mobile-counter').textContent = (index + 1) + ' of ' + results.length + (results.length === 1 ? ' match' : ' matches');
      this.role('mobile-previous').disabled = !!this._slide || index <= 0;
      this.role('mobile-next').disabled = !!this._slide || index === results.length - 1;
      this.role('mobile-hint').hidden = results.length < 2;
      this.role('mobile-dimensions').textContent = [mold.length,mold.width,mold.depth].map(v => this.measure(v)).join(' × ') + this.unitLabel() + ' inside';
      this.role('mobile-yield').textContent = result.capacity + ' bars / mold';
      this.role('mobile-count').textContent = result.needed + (result.needed === 1 ? ' mold' : ' molds') + ' needed · capacity ' + result.needed * result.capacity + ' bars';
      const cubicInches = mold.length * mold.width * mold.depth,oilPounds = cubicInches * 0.025;
      this.role('mobile-oil').textContent = this.number(oilPounds,1) + ' lb / ' + this.number(oilPounds * 0.45359237,2) + ' kg';
      this.role('mobile-volume').textContent = this.number(cubicInches * 0.016387064,2) + ' L / ' + this.number(cubicInches * 128 / 231,1) + ' US fl oz';
      this.role('mobile-price').textContent = mold.price;
      const link = this.role('mobile-link');
      link.hidden = !mold.url;
      if (mold.url) link.href = mold.url;
      else link.removeAttribute('href');
      link.setAttribute('aria-label','View ' + mold.name + ' mold');
      this.role('mobile-buy').hidden = !mold.price && !mold.url;
      this.role('mobile-unavailable').hidden = !mold.unavailable;
      this.updateFloatingVisibility();
    }

    sliderMetrics() {
      const track = this.role('results');
      const first = track.firstElementChild;
      if (!first || !track.clientWidth) return null;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const stride = first.getBoundingClientRect().width + gap;
      const count = track.children.length;
      const perPage = Math.max(1,Math.round((track.clientWidth + gap) / stride));
      return { track,stride,count,perPage,first:Math.max(0,Math.round(track.scrollLeft / stride)) };
    }

    syncSlider() {
      const metrics = this.sliderMetrics();
      if (!metrics) return;
      const { track,count,perPage,first } = metrics;
      const last = Math.min(first + perPage,count);
      const text = (first + 1) + '–' + last + ' of ' + count + (count === 1 ? ' match' : ' matches');
      if (this.role('slider-counter').textContent !== text) this.role('slider-counter').textContent = text;
      this.role('previous').disabled = track.scrollLeft <= 1;
      this.role('next').disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    }

    moveSlider(direction) {
      const metrics = this.sliderMetrics();
      if (!metrics) return;
      const { track,count,perPage,first,stride } = metrics;
      const index = Math.max(0,Math.min(Math.max(0,count - perPage),first + direction * perPage));
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left:index * stride, behavior:reduced ? 'auto' : 'smooth' });
    }

    trims(result, values) {
      const usedAcross = result.loaves * values.width, usedAlong = result.slices * values.thickness;
      const side = Math.max(0,result.across - usedAcross), end = Math.max(0,result.along - usedAlong);
      const sideTrim = side < 1e-7 ? 0 : side, endTrim = end < 1e-7 ? 0 : end;
      const split = this._fields.split.checked;
      return { usedAcross,usedAlong,left:split ? sideTrim / 2 : 0,right:split ? sideTrim / 2 : sideTrim,start:split ? endTrim / 2 : 0,end:split ? endTrim / 2 : endTrim };
    }

    draw() {
      if (!this._view || !this.isConnected) return;
      const result = this._view.results.find(r => r.mold.id === this._selected);
      if (!result) return;
      const values = this._view.values, trim = this.trims(result,values);
      const host = this.role('diagram'), width = host.getBoundingClientRect().width;
      if (width < 1) return;
      const mobileSides = this.isMobile() && (trim.left > 0 || trim.right > 0);
      const wide = width >= 600 && !mobileSides;
      const leftInset = mobileSides && trim.left > 0 ? 30 : 8;
      const rightInset = mobileSides && trim.right > 0 ? 72 : 46;
      const padding = wide ? 400 : leftInset + rightInset;
      const scale = Math.min(Math.max(1,width - padding) / result.across,(wide ? 320 : 280) / result.along,470 / result.across);
      const pw = result.across * scale, ph = result.along * scale;
      const sideText = amount => this.measure(amount,true) + this.unitLabel();
      const labelRoom = mobileSides ? Math.max(
        trim.left > 0 ? ('Left trim: ' + sideText(trim.left)).length : 0,
        trim.right > 0 ? ('Right trim: ' + sideText(trim.right)).length : 0
      ) * 6.5 + 12 : 0;
      const extra = Math.max(0,(labelRoom - trim.usedAlong * scale) / 2);
      const y = wide ? 104 : 56 + extra;
      const x = wide ? (width - pw) / 2 : leftInset;
      const bx = x + trim.left * scale, by = y + trim.start * scale;
      const bw = trim.usedAcross * scale, bh = trim.usedAlong * scale;
      const height = y + ph + (wide ? 92 : 20 + extra);
      const svg = this.svg('svg',{ viewBox:'0 0 ' + width + ' ' + height, height, role:'img', 'aria-label':result.mold.name + ': ' + result.loaves + ' loaves, ' + result.slices + ' slices per loaf, ' + result.capacity + ' bars per mold' });
      const line = (x1,y1,x2,y2) => svg.appendChild(this.svg('line',{ x1,y1,x2,y2,stroke:'var(--cct-plan-ink)','stroke-opacity':'.55','stroke-width':1 }));
      const text = (x1,y1,value,anchor,className) => svg.appendChild(this.svg('text',{ x:x1,y:y1,'text-anchor':anchor || 'middle',class:className || '' },value));
      const trimSize = amount => this.measure(amount,true) + this.unitLabel();
      const trimAmount = amount => this.measure(amount,true) + this.unitLabel();
      svg.appendChild(this.svg('rect',{ x,y,width:pw,height:ph,rx:2,fill:'color-mix(in srgb,var(--cct-plan-ink) 13%,var(--cct-plan-paper))' }));
      svg.appendChild(this.svg('rect',{ x:bx,y:by,width:bw,height:bh,fill:'color-mix(in srgb,var(--cct-plan-accent) 38%,var(--cct-plan-paper))' }));
      const loafStep = Math.max(1,Math.ceil(result.loaves / 80)), sliceStep = Math.max(1,Math.ceil(result.slices / 100));
      for (let i = loafStep; i < result.loaves; i += loafStep) {
        svg.appendChild(this.svg('line',{ x1:bx + i * values.width * scale,x2:bx + i * values.width * scale,y1:by,y2:by + bh,stroke:'var(--cct-plan-paper)','stroke-width':1.5 }));
      }
      for (let i = sliceStep; i < result.slices; i += sliceStep) {
        svg.appendChild(this.svg('line',{ x1:bx,x2:bx + bw,y1:by + i * values.thickness * scale,y2:by + i * values.thickness * scale,stroke:'var(--cct-plan-paper)','stroke-width':1 }));
      }
      line(x,34,x + pw,34); line(x,29,x,39); line(x + pw,29,x + pw,39);
      text(x + pw / 2,22,this.measure(result.across) + this.unitLabel() + (wide ? ' mold width' : ''),'middle',wide ? '' : 'cct-plan__compact-dimension');
      const dimensionX = x + pw + (wide ? 170 : (mobileSides && trim.right > 0 ? 44 : 22)), dimensionCenter = y + ph / 2;
      line(dimensionX,y,dimensionX,y + ph); line(dimensionX - 5,y,dimensionX + 5,y); line(dimensionX - 5,y + ph,dimensionX + 5,y + ph);
      svg.appendChild(this.svg('text',{ x:dimensionX + 16,y:dimensionCenter,'text-anchor':'middle',transform:'rotate(-90 ' + (dimensionX + 16) + ' ' + dimensionCenter + ')',class:wide ? '' : 'cct-plan__compact-dimension' },this.measure(result.along) + this.unitLabel() + (wide ? ' mold length' : '')));
      const descriptions = [];
      const addTrim = (name,a,b) => descriptions.push({ name,size:trimSize(a,b) });
      const labelY = by + bh / 2;
      if (trim.left > 0) {
        addTrim('Left trim',trim.left,trim.usedAlong);
        if (wide) { line(x + trim.left * scale / 2,labelY,x - 16,labelY); text(x - 26,labelY - 8,'Left trim','end','cct-plan__trim-label'); text(x - 26,labelY + 14,trimSize(trim.left,trim.usedAlong),'end','cct-plan__trim-value'); }
        if (mobileSides) {
          line(x + trim.left * scale / 2,labelY,x - 6,labelY);
          svg.appendChild(this.svg('text',{ x:12,y:labelY,'text-anchor':'middle',transform:'rotate(-90 12 ' + labelY + ')',class:'cct-plan__side-trim' },'Left trim: ' + trimAmount(trim.left)));
        }
      }
      if (trim.right > 0) {
        addTrim('Right trim',trim.right,trim.usedAlong);
        if (wide) { line(x + pw - trim.right * scale / 2,labelY,x + pw + 16,labelY); text(x + pw + 26,labelY - 8,'Right trim','start','cct-plan__trim-label'); text(x + pw + 26,labelY + 14,trimSize(trim.right,trim.usedAlong),'start','cct-plan__trim-value'); }
        if (mobileSides) {
          line(x + pw - trim.right * scale / 2,labelY,x + pw + 6,labelY);
          const labelX = x + pw + 16;
          svg.appendChild(this.svg('text',{ x:labelX,y:labelY,'text-anchor':'middle',transform:'rotate(-90 ' + labelX + ' ' + labelY + ')',class:'cct-plan__side-trim' },'Right trim: ' + trimAmount(trim.right)));
        }
      }
      if (wide && !trim.left && !trim.right) {
        text(x - 25,labelY - 6,'Exact width fit','end','cct-plan__trim-label');
        text(x - 25,labelY + 16,'No side trim','end','cct-plan__trim-value');
      }
      if (trim.start > 0) {
        descriptions.push({ name:'End trim 1',size:trimAmount(trim.start) });
        if (wide) { line(x + pw / 2,y + trim.start * scale / 2,x + pw / 2,y - 17); text(x + pw / 2,y - 50,'End trim','middle','cct-plan__trim-label'); text(x + pw / 2,y - 29,trimAmount(trim.start),'middle','cct-plan__trim-value'); }
      }
      if (trim.end > 0) {
        descriptions.push({ name:trim.start ? 'End trim 2' : 'End trim',size:trimAmount(trim.end) });
        if (wide) { line(x + pw / 2,by + bh + trim.end * scale / 2,x + pw / 2,y + ph + 23); text(x + pw / 2,y + ph + 44,'End trim','middle','cct-plan__trim-label'); text(x + pw / 2,y + ph + 66,trimAmount(trim.end),'middle','cct-plan__trim-value'); }
      }
      svg.appendChild(this.svg('desc',{},descriptions.map(t => t.name + ': ' + t.size).join('; ') || 'No leftover trim.'));
      host.replaceChildren(svg);
      const trimList = this.role('trim-list');
      trimList.replaceChildren();
      const listedTrims = mobileSides ? descriptions.filter(t => t.name !== 'Left trim' && t.name !== 'Right trim') : descriptions;
      listedTrims.forEach(t => {
        const item = this.element('span');
        item.append(this.element('span','',t.name),this.element('strong','',t.size));
        trimList.appendChild(item);
      });
      trimList.hidden = wide || !listedTrims.length;
      this.role('layout-title').textContent = result.mold.name + ' · cutting layout';
      this.role('layout-caption').textContent = result.loaves + ' loaves × ' + this.measure(values.width) + this.unitLabel() + ' wide · ' + result.slices + ' slices × ' + this.measure(values.thickness) + this.unitLabel() + ' thick';
      this.role('summary').textContent = result.loaves + ' loaves × ' + result.slices + ' slices = ' + result.capacity + ' bars at a ' + this.measure(values.height) + this.unitLabel() + ' pour depth';
      this.role('remainder-key').hidden = !descriptions.length;
      this.role('diagram-note').hidden = loafStep === 1 && sliceStep === 1;
    }

    svg(tag, attributes, text) {
      const node = document.createElementNS('http://www.w3.org/2000/svg',tag);
      Object.entries(attributes).forEach(([key,value]) => node.setAttribute(key,value));
      if (text !== undefined) node.textContent = text;
      return node;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
